module.exports = __webpack_public_path__ + "img/3-5.b502c221.svg";